import {
  Button,
  formatApplicationStatus,
  isActiveApplicationStatus,
  canReapplyAfterWithdraw,
  isBlockedApplicationStatus,
} from '@yeshuman/sdk'
import { Check, Send } from 'lucide-react'
import type { ApplicationStatusEntry } from '../../hooks/use-my-applications'

type JobApplicationTrailingProps = {
  application?: Pick<ApplicationStatusEntry, 'status'> | null
  onApply: () => void
}

/** Shared job-card / dashboard trailing action for apply vs pipeline vs terminal states. */
export function JobApplicationTrailing({ application, onApply }: JobApplicationTrailingProps) {
  if (!application || application.status === 'draft') {
    return (
      <Button
        type="button"
        size="sm"
        onClick={(event) => {
          event.stopPropagation()
          onApply()
        }}
      >
        <Send className="mr-1.5 shrink-0" aria-hidden />
        Apply
      </Button>
    )
  }

  if (isActiveApplicationStatus(application.status)) {
    return (
      <Button type="button" size="sm" variant="successMuted" disabled>
        <Check className="mr-1.5 shrink-0" aria-hidden />
        Applied
      </Button>
    )
  }

  if (canReapplyAfterWithdraw(application.status)) {
    return (
      <Button
        type="button"
        size="sm"
        onClick={(event) => {
          event.stopPropagation()
          onApply()
        }}
      >
        <Send className="mr-1.5 shrink-0" aria-hidden />
        Apply again
      </Button>
    )
  }

  if (isBlockedApplicationStatus(application.status)) {
    return (
      <Button type="button" size="sm" variant="secondary" disabled>
        {formatApplicationStatus(application.status)}
      </Button>
    )
  }

  return null
}

export function hasActiveApplicationForOpportunity(
  applicationStatusMap: Record<string, Pick<ApplicationStatusEntry, 'status'> | undefined>,
  opportunityId: string,
): boolean {
  const application = applicationStatusMap[opportunityId]
  return application != null && isActiveApplicationStatus(application.status)
}
